import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

const getSaleAgentsList = async (ctx: QueryFunctionContext) => {
  const {data}: {data: ISaleAgent[]} = await request.get(
    `api/v2/store/user-sale-agent/${ctx.queryKey[1]}`,
  );
  return data;
};

export default getSaleAgentsList;
